<script setup lang="ts">
import { DropdownMenuLabel } from 'reka-ui';
</script>

<template>
    <DropdownMenuLabel class="text-muval-gray-3 px-3 py-1.5 text-xs font-semibold">
        <slot />
    </DropdownMenuLabel>
</template>
